module.exports = __webpack_public_path__ + "img/pdf1.3a9de7a7.png";